import styled from 'styled-components';

export const WrapperCreate = styled.div`
  display: flex;

  .title-create {
    font-size: 18px;
    font-weight: bold;
    margin: 10px;
  }
  .button-create {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 0px 18px 0px 18px;
  }
`;

export const ButtonDocument = styled.button`
  display: flex;
`;
